import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

interface OrigemDTO {
  descricaoOrigem: string;
  idOrigem: number;
}

interface GetOrigemResponse {
  Item: OrigemDTO[];
  erro: string;
}

@Injectable()
export class OrigemProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }
  
  /**
   * Lista origens de comunicados
   */
  get(): Promise<GetOrigemResponse> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'origem';
      
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData[0].status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta dos contratos.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }
}
